import { Tag } from "antd";
import moment from "moment";

const STATUS_COLORS = {
  draft: "default",
  inReview: "orange",
  published: "green",
  archived: "red",
};

const STATUS_LABELS = {
  draft: "Brouillon",
  inReview: "En revue",
  published: "Publié",
  archived: "Archivé",
};

const VersionList = ({ versions, activeVersionId, onSelect }) => (
  <div className="screen-studio__versions">
    <h4>Versions</h4>
    {versions.map((version) => (
      <div
        key={version.id}
        className={`screen-studio__version-item ${version.id === activeVersionId ? "screen-studio__version-item--active" : ""}`}
        onClick={() => onSelect(version.id)}
      >
        <div className="screen-studio__version-header">
          <span>v{version.versionNumber}</span>
          <Tag color={STATUS_COLORS[version.status] || "default"}>
            {STATUS_LABELS[version.status] || version.status}
          </Tag>
        </div>
        <small>{moment(version.createdDate).format("DD/MM/YYYY HH:mm")}</small>
      </div>
    ))}
  </div>
);

export default VersionList;
